import React, { useState } from "react";

export default function ContactPage() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();

      setTimeout(() => setDone(false), 4000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ PREMIUM CSS */}
      <style>{`
        .contact-banner {
          height: 330px;
          background: url('/slider4.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }

        .contact-banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .contact-banner h1 {
          font-size: 50px;
          font-weight: 800;
          z-index: 2;
          animation: fadeUp 1s ease;
        }

        .section {
          padding: 85px 0;
          background: #f6f9ff;
        }

        .contact-card {
          background: rgba(255, 255, 255, 0.9);
          padding: 40px;
          border-radius: 20px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 12px 35px rgba(0,0,0,0.12);
          animation: fadeUp 1s ease forwards;
        }

        .info-box {
          background: #ffffff;
          padding: 22px;
          border-radius: 15px;
          box-shadow: 0px 10px 28px rgba(0,0,0,0.08);
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          animation: fadeUp 1s ease;
        }

        .info-box i {
          font-size: 29px;
          color: #005eff;
          margin-right: 12px;
        }

        .info-label {
          font-size: 17px;
          font-weight: 700;
          margin-bottom: 3px;
        }

        .info-desc {
          font-size: 15px;
          color: #444;
        }

        .hours-box {
          background: #eef3ff;
          padding: 16px;
          border-radius: 14px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          margin-bottom: 18px;
          animation: fadeUp 1s ease;
        }

        .form-control {
          border-radius: 12px;
          padding: 14px;
          border: 1px solid #cbd6ff;
          font-size: 15px;
          transition: 0.3s ease;
        }

        .form-control:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
        }

        .submit-btn {
          width: 100%;
          background: linear-gradient(90deg, #005eff, #0040ce);
          color: white;
          font-size: 17px;
          font-weight: 700;
          padding: 14px;
          border-radius: 12px;
          border: none;
          transition: 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-4px);
          box-shadow: 0px 12px 28px rgba(0,64,200,0.3);
        }

        .loading, .success {
          margin-top: 12px;
          font-size: 16px;
          font-weight: 600;
          animation: fadeUp 0.6s ease;
        }

        .loading { color: #005eff; }
        .success { color: #09b36b; }

        /* ⭐ FULL WIDTH MAP */
        .full-map-wrapper {
          margin-top: 0;
          width: 100%;
        }

        .full-map {
          width: 100%;
          height: 420px;
          border: none;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="contact-banner">
        <h1>Contact Our U.S. Support Team</h1>
      </div>

      {/* ⭐ MAIN CONTACT SECTION */}
      <section className="section">
        <div className="container">
          <div className="row g-5">

            {/* ⭐ LEFT INFO COLUMN */}
            <div className="col-lg-5">

              <div className="info-box">
                <i className="bi bi-geo-alt-fill"></i>
                <div>
                  <div className="info-label">Corporate Mailing Address</div>
                  <div className="info-desc">
                    3800 Cabell Dr, Irving, TX 75063, United States
                  </div>
                </div>
              </div>

              <div className="info-box">
                <i className="bi bi-envelope-fill"></i>
                <div>
                  <div className="info-label">Support Email</div>
                  <div className="info-desc">info@swiftship.us</div>
                </div>
              </div>

              <div className="info-box">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  <div className="info-label">Customer Service</div>
                  <div className="info-desc">(480) 520-0274</div>
                </div>
              </div>

              <div className="hours-box">
                <strong>Business Hours:</strong><br />
                Monday – Friday: 9:00 AM – 6:00 PM (MST)<br />
                Response Time: Within 24 business hours
              </div>

            </div>

            {/* ⭐ RIGHT CONTACT FORM */}
            <div className="col-lg-7">
              <div className="contact-card">

                <h2 className="fw-bold mb-4">Send Us a Message</h2>

                <p className="text-muted mb-4" style={{ fontSize: "15px" }}>
                  Our support team is available Monday–Friday.  
                  For shipment inquiries, please include tracking or order details.
                </p>

                <form onSubmit={handleSubmit}>
                  <input className="form-control mb-3" placeholder="Your Full Name" required />
                  <input className="form-control mb-3" placeholder="Email Address" required />
                  <input className="form-control mb-3" placeholder="Phone Number" required />
                  <textarea
                    className="form-control mb-3"
                    rows="4"
                    placeholder="Write your message here..."
                    required
                  ></textarea>

                  <button className="submit-btn" disabled={loading}>
                    {loading ? "Sending..." : "Send Message →"}
                  </button>

                  {loading && <div className="loading">Submitting your request...</div>}
                  {done && <div className="success">Thank you! Our team will contact you soon.</div>}
                </form>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ⭐ FULL WIDTH MAP BELOW EVERYTHING */}
      <div className="full-map-wrapper">
        <iframe
          className="full-map"
          title="Full Width Map"
          src="https://www.google.com/maps?q=3800%20Cabell%20Dr,%20Irving,%20TX%2075063,%20United%20States&output=embed"
        ></iframe>
      </div>

    </>
  );
}
